import { Box, Button, Grid, Icon, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import { ModalContext } from "../../../shared/components";
import { VForm, useVForm } from "../../../shared/forms";
import { format, isValid, parseISO } from "date-fns";

interface ModalConfirmBilletProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	id: string;
	clientName: string;
	dueDate?: string;
	onchangeDueDate: (dueDate: string) => void;
	isLoading?: boolean;
}

export const ModalConfirmBillet: React.FC<ModalConfirmBilletProps> = ({ isOpen, onClose, onConfirm, clientName, dueDate, onchangeDueDate, isLoading = false }) => {
	const { formRef } = useVForm();
	const theme = useTheme();
	const smDown = useMediaQuery(theme.breakpoints.down("sm"));

	const parsedDueDate = (() => {
		if (!dueDate) return null;
		const normalizedValue = dueDate.replace(" ", "T");
		const parsedDate = parseISO(normalizedValue);
		return isValid(parsedDate) ? parsedDate : null;
	})();

	return (
		<ModalContext
			isCloseModal={() => {
				if (!isLoading) onClose();
			}}
			isOpenModal={isOpen}
			messageType={"question"}
			showButtonCancel={false}
			showButtonConfirm={false}
			textButtonConfirm={"Gerar"}
			textButtonCancel={"Voltar"}
			showTitleIcon={true}
			maxWidth="40%"
			onclickConfirm={() => {
				if (!isLoading) onConfirm();
			}}
			ITitle={"Confirma geração do boleto ?"}
			IMessage={[
				<Box>
					<VForm
						id="formIdGenerateInvoice"
						placeholder="Your placeholder"
						ref={formRef}
						onSubmit={() => onConfirm()}
						onPointerEnterCapture={() => {}}
						onPointerLeaveCapture={() => {}}
					>
						<Grid display={"flex"} flexDirection={"row"} gap={1}>
							<Grid item xs={1} sx={{ textAlign: "left" }}>
								<Typography variant="body1" sx={{ fontWeight: "bold" }}>
									Cliente:
								</Typography>
							</Grid>
							<Grid item xs={5} sx={{ alignItems: "left" }}>
								<Typography variant="body1">{clientName}</Typography>
							</Grid>
						</Grid>
						<Grid display={"flex"} flexDirection={"row"} gap={1}>
							<Grid item xs={1} sx={{ textAlign: "left" }}>
								<Typography variant="body1" sx={{ fontWeight: "bold" }}>
									Vencimento:
								</Typography>
							</Grid>
							<Grid item xs={5} sx={{ alignItems: "left" }}>
								<Typography variant="body1">{parsedDueDate ? format(parsedDueDate, "dd/MM/yyyy") : ""}</Typography>
							</Grid>
						</Grid>

						<TextField
							fullWidth
							label="Vencimento"
							name="dueDate"
							disabled={isLoading}
							size="small"
							type="date"
							InputLabelProps={{ shrink: true, required: true }}
							value={parsedDueDate ? format(parsedDueDate, "yyyy-MM-dd") : ""}
							sx={{ marginTop: 2, marginBottom: 2 }}
							onChange={(e) => {
								onchangeDueDate(e.target.value + " 12:00:00");
							}}
						/>

						<Grid
							container
							sm={12}
							sx={{ border: "none", display: "flex", justifyContent: "center" }}
							display={"flex"}
							flexDirection={smDown ? "column" : "row"}
							padding={2}
							gap={2}
						>
							<Button color="inherit" disableElevation variant={"contained"} startIcon={<Icon> arrow_back_Ico</Icon>} onClick={onClose} disabled={isLoading}>
								{"Voltar"}
							</Button>
							<Button
								color="primary"
								disableElevation
								variant={"contained"}
								startIcon={<Icon> checkIcon</Icon>}
								disabled={isLoading}
								onClick={() => {
									if (!isLoading) onConfirm();
								}}
							>
								{isLoading ? "Gerando..." : "Confirmar"}
							</Button>
						</Grid>
					</VForm>
				</Box>,
			]}
		/>
	);
};
